
/*
 * COSTUMIA CONTENT PROTECTION V1.0
 * Protezione dei contenuti pubblici Shopify.
 * Deterrente contro copie occasionali.
 */

(() => {
  'use strict';

  if (window.CostumiaProtectionLoaded) return;
  window.CostumiaProtectionLoaded = true;

  // Non attivare nell'editor Shopify.
  if (window.Shopify && window.Shopify.designMode) return;

  const CONFIG = {
    blockRightClick: true,
    blockImageDrag: true,
    blockCopy: true,
    blockSelection: true,
    blockSaveShortcut: true,
    showNotice: true,
    noticeDuration: 2600,
    notice:
      'I contenuti e le immagini di Costumia sono protetti. ' +
      'È vietata la riproduzione non autorizzata.'
  };

  const EDITABLE_SELECTOR = [
    'input',
    'textarea',
    'select',
    '[contenteditable=""]',
    '[contenteditable="true"]',
    '[role="textbox"]',
    '.shopify-payment-button'
  ].join(',');

  function isEditable(target) {
    return target instanceof Element &&
      Boolean(target.closest(EDITABLE_SELECTOR));
  }

  function isExcluded(target) {
    if (!(target instanceof Element)) return false;

    return Boolean(target.closest([
      EDITABLE_SELECTOR,
      '[data-costumia-protection-exclude]',
      '.shopify-challenge__container',
      '.grecaptcha-badge'
    ].join(',')));
  }

  let noticeTimer = null;

  function showNotice() {
    if (!CONFIG.showNotice) return;

    let notice = document.getElementById(
      'costumia-protection-notice'
    );

    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'costumia-protection-notice';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      notice.textContent = CONFIG.notice;
      document.body.appendChild(notice);
    }

    notice.classList.add('is-visible');

    clearTimeout(noticeTimer);

    noticeTimer = setTimeout(() => {
      notice.classList.remove('is-visible');
    }, CONFIG.noticeDuration);
  }

  function preventAndNotify(event) {
    event.preventDefault();
    showNotice();
  }

  // Blocca il menu del tasto destro sui contenuti.
  document.addEventListener('contextmenu', (event) => {
    if (!CONFIG.blockRightClick) return;
    if (isExcluded(event.target)) return;

    preventAndNotify(event);
  });

  // Blocca il trascinamento delle immagini.
  document.addEventListener('dragstart', (event) => {
    if (!CONFIG.blockImageDrag) return;
    if (isExcluded(event.target)) return;

    const target = event.target;

    if (
      target instanceof Element &&
      target.closest('img, picture, svg')
    ) {
      event.preventDefault();
    }
  });

  // Impedisce la copia tramite menu o Ctrl+C
  // fuori dai campi compilabili.
  document.addEventListener('copy', (event) => {
    if (!CONFIG.blockCopy) return;
    if (isExcluded(event.target)) return;

    preventAndNotify(event);
  });

  // Scorciatoie: limita copia e salvataggio.
  document.addEventListener('keydown', (event) => {
    if (isExcluded(event.target) || isEditable(event.target)) {
      return;
    }

    const modifier = event.ctrlKey || event.metaKey;
    const key = String(event.key).toLowerCase();

    if (modifier && CONFIG.blockCopy && key === 'c') {
      preventAndNotify(event);
      return;
    }

    if (modifier && CONFIG.blockSaveShortcut && key === 's') {
      preventAndNotify(event);
    }
  });

  // Limita la selezione dei contenuti non interattivi.
  document.addEventListener('selectstart', (event) => {
    if (!CONFIG.blockSelection) return;
    if (isExcluded(event.target)) return;

    const target = event.target;

    if (
      target instanceof Element &&
      target.closest('p, h1, h2, h3, h4, h5, h6, li')
    ) {
      event.preventDefault();
    }
  });

  // Evita il drag nativo delle fotografie.
  function protectImages() {
    document.querySelectorAll('img').forEach((img) => {
      if (img.closest('[data-costumia-protection-exclude]')) {
        return;
      }

      img.setAttribute('draggable', 'false');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      protectImages,
      { once: true }
    );
  } else {
    protectImages();
  }

})();
